import {
  ChatAttachment,
  ChatBubble,
  ChatMeta,
} from '@eriko/ui/src/components/ui/chat';
import { cn } from '@eriko/ui/src/lib/utils';
import type { ChatMessage } from '../../../stores/chatStore';

interface UserMessageProps {
  msg: ChatMessage;
}

function stripAttachedFilesBlock(content: string): string {
  return content.replace(/\n?\n?\[Attached files:\n[\s\S]*?\n\]\s*$/, '').trim();
}

function extractFilesFromContent(content: string): { fileName: string; fileType: string }[] {
  const match = content.match(/\[Attached files:\n([\s\S]*?)\n\]/);
  if (!match?.[1]) return [];
  return match[1]
    .split('\n')
    .map((line) => {
      const m = line.match(/^- (.+?) \((\w+)\)/);
      return m?.[1] ? { fileName: m[1], fileType: m[2] ?? '' } : null;
    })
    .filter((f): f is { fileName: string; fileType: string } => f !== null);
}

export function UserMessage({ msg }: UserMessageProps) {
  const files = msg.files?.length ? msg.files : extractFilesFromContent(msg.content);
  const displayContent = stripAttachedFilesBlock(msg.content);

  return (
    <div className="flex justify-end gap-3 animate-[fade-up_0.25s_ease-out]">
      <div className="max-w-[78%]">
        <ChatMeta name="You" time={msg.timestamp} align="right" />
        <ChatBubble variant="user">
          {displayContent && (
            <p className="text-sm leading-relaxed whitespace-pre-wrap">{displayContent}</p>
          )}
          {files.length > 0 && (
            <div
              className={cn(
                'flex flex-wrap gap-1.5',
                displayContent && 'mt-2 pt-2 border-t border-surface-0/15',
              )}
            >
              {files.map((f, i) => (
                <ChatAttachment key={i} fileName={f.fileName} dark />
              ))}
            </div>
          )}
        </ChatBubble>
      </div>
    </div>
  );
}
